import { gql } from "@apollo/client"
export const LoginMutation = gql`
  query login($mobileNumber: String!, $password: String!) {
    loginUser(mobileNumber: $mobileNumber, password: $password) {
      token
      userId
      mobileNumber
      name
      lastLoginDateTime
      pageAccess {
        id
        name
      }
      pageComponentAccess {
        id
        name
        isItemSpecific
        uiModuleId
      }
      error {
        message
      }
    }
  }
`

export const forceChangePasswordMutation = gql`
  mutation forcePasswordChange(
    $mobileNumber: String!
    $password: String!
    $newPassword: String!
  ) {
    forcePasswordChange(
      userName: $userName
      newPassword: $newPassword
      password: $password
    ) {
      id
      status
      error {
        message
      }
    }
  }
`
export const changePasswordMutation = gql`
  mutation passwordChange($password: String!, $newPassword: String!) {
    passwordChange(password: $password, newPassword: $newPassword) {
      id
      status
      error {
        message
      }
    }
  }
`
